<template>
  <div
    style="padding: 20px; position: relative; overflow: hidden; height: 100%"
  >
    <div
      style="
        border: 1px solid #e2e2e2;
        border-radius: 10px;
        overflow: hidden;
        height: 100%;
      "
    >
      <ul
        style="
          background-color: #f6f6f6;
          display: flex;
          align-items: center;
          padding: 10px 20px;
        "
      >
        专项附加扣除明细
      </ul>
      <ul style="padding: 20px">
        <table class="essential-detail-record-table" cellpadding="10">
          <tr>
            <td>姓名</td>
            <td>{{ state.model.xm }}</td>
            <td>证件类型</td>
            <td>{{ state.model.zzlx }}</td>
            <td>证件号</td>
            <td colspan="2">{{ state.model.zzhm }}</td>
          </tr>
          <tr>
            <td>税局</td>
            <td>{{ state.model.tax_bureau_name || "-" }}</td>
            <td>登记序号</td>
            <td>{{ state.model.bizNo }}</td>
            <td>扣缴义务人</td>
            <td>{{ state.model.withholding_agent_name }}</td>
            <td>统一社会信用代码</td>
            <td>{{ state.model.unified_social_credit_identifier }}</td>
          </tr>
        </table>
      </ul>
      <ul style="flex: 1; padding: 0 20px">
        <el-tabs
          v-model="state.activeName"
          class="detail-tabs"
          @tab-click="handleClick"
        >
          <el-tab-pane label="核算数据" name="hssj">
            <c_Record :employee_id="props.data?.employee_id"></c_Record>
          </el-tab-pane>
        </el-tabs>
      </ul>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { essential_detail } from "@/http/essential";

import c_Record from "./Detail/Record.vue";

export default {
  components: {
    c_Record,
  },
  props: {
    data: Object,
  },
  setup(props) {
    const state = reactive({
      model: {},
      activeName: "hssj",
    });
    onMounted(() => {
      essential_detail(props.data?.id).then((res) => {
        if (res.status == 200) state.model = res.data.data;
      });
    });
    return { state, props };
  },
};
</script>
<style scoped>
.essential-detail-record-table {
  width: 100%;
  font-size: 14px;

  & td:nth-child(2n + 1) {
    color: #a2a2a2;
    text-align: right;
  }

  & td:nth-child(2n) {
    text-align: left;
  }
}
</style>
